import { RackTypeEnum } from "@gtpl/shared-models/common-models";
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Locations } from "../locations/location.entity";
import { RackPosition } from "../rack-position/rack-position.entity";
import { RackZoneMapping } from "../rack-zone-mapping/rack-zone-mapping-entity";
import { RmRackPosition } from "../rm-rack-position/rm-rack-position.entity";
import { RmZones } from "../rm-zones/rm-zones.entity";
import { ZoneMaster } from "../zone-master/zone-master.entity";

@Entity('rm_rack')
export class RmRack {
  @PrimaryGeneratedColumn('increment', { name: 'rm_rack_id' })
  rmRackId: number;


  @Column("varchar",{
    nullable:false,
    length:20,
    name:"rm_rack_code"
  })
  rmRackCode:string;

  @Column('varchar', {
    nullable: false,
    length: 30,
    name: 'rm_rack_name',
  })
  rmRackName: string;  

  @Column("int", {
    nullable: true,
    name: "zone_id"
  })
  zoneId: number;

  @Column("int", {
    nullable: true,
    name: "allocated_zone_id"
  })
  allocatedZoneId: number;
  
  @Column('boolean', {
    nullable: false,
    default: true,
    name: 'is_active',
  })
  isActive: boolean;
  @Column('int', {
    nullable: true,
    default: 0,
    name: 'reserved_for_dummy',
  })
  reservedForDummy: number;

  @Column({
    type: 'enum',
    enum: RackTypeEnum,
    nullable: false,
    default: RackTypeEnum.Center,
    name: 'rm_rack_type'
  })
  rmRackPosition: RackTypeEnum;

  @Column('int', {
    nullable: true,
    default: 0,
    name: 'rm_rack_status',
  })
  rmRackStatus: number;

  @CreateDateColumn({
    name: 'created_at',
    type: 'datetime',
  })
  createdAt: Date;

  @Column('varchar', {
    nullable: false,
    name: 'created_user',
    length: 50,
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: 'updated_at',
    type: 'datetime',
  })
  updatedAt: Date;

  @Column('varchar', {
    nullable: true,
    name: 'updated_user',
    length: 50,
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: 'version_flag',
  })
  versionFlag: number;
  
  @ManyToOne(type => RmZones, zone => zone.rmRacksInfo, { nullable: false, })
  @JoinColumn({ name: "zone_id" })
  rmZonesInfo: RmZones;

  @OneToMany((type) => RackZoneMapping, (rack) => rack.rackInfo)
  rmRackZoneInfo: RackZoneMapping[];

  @OneToMany(type => Locations, loc => loc.rmRackInfo)
  locationsInfo: Locations[];

  @OneToMany(type => RmRackPosition, rcp => rcp.rmRackMasterInfo)
  rmRackPositionInfo: RmRackPosition[];

  @Column('integer', {
    nullable: true,
    name: 'plant_id'
  })
  plantId: number;

  @Column('integer', {
    nullable: true,
    name: 'allocated_plant_id'
  })
  allocatedPlantId: number;

}
